module.exports = __webpack_public_path__ + "media/images/icon-arrow-down-9de49facb3600f99f1b2775f5ef87ece.png";